import { StrategyBuilderFunction, EMPTY_STRATEGY } from './types';
import { addLongCall, addShortCall } from './addOption';
import {
  getDefaultExpiration,
  findClosestStrikePrice,
  getStrikesAtExpiration,
  expirationToDate,
  getPremium,
  getStrategyLegStrikeDirection,
  getStrikeDistance,
} from './utils';

export const bullCallLadder: StrategyBuilderFunction = ({
  chain,
  spot,
  expirationDate,
  expirationKey,
  strikeDirection,
  contractMultiplier = 1,
}) => {
  const strikesAtExpiration = expirationKey
    ? getStrikesAtExpiration(chain, expirationKey)
    : getDefaultExpiration(chain);

  if (
    !strikesAtExpiration ||
    !strikesAtExpiration.e ||
    !strikesAtExpiration.ey ||
    !strikesAtExpiration.em ||
    !strikesAtExpiration.ed
  ) {
    return EMPTY_STRATEGY;
  }

  // Determine expiration date for options
  const expirationDateForOptions =
    expirationDate ||
    expirationToDate(strikesAtExpiration.ey, strikesAtExpiration.em, strikesAtExpiration.ed);
  const expirationKeyForOptions = expirationKey || strikesAtExpiration.e;

  // Calculate strikes for each leg of the Bull Call Ladder
  const inTheMoneyStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: -2 }),
  );
  const atTheMoneyStrike = findClosestStrikePrice(strikesAtExpiration, spot);
  const outOfTheMoneyStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: 2 }),
  );

  return {
    optionPositions: [
      addLongCall({
        strike: inTheMoneyStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[inTheMoneyStrike]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[inTheMoneyStrike]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'long'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
      addShortCall({
        strike: atTheMoneyStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[atTheMoneyStrike]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[atTheMoneyStrike]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
      addShortCall({
        strike: outOfTheMoneyStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[outOfTheMoneyStrike]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[outOfTheMoneyStrike]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
    ],
    stockPositions: [],
  };
};
